











import { Component, Vue } from 'vue-property-decorator'
import { Meta } from '@/helpers/decorators'

import Tabs from '@/components/common/Tabs.vue'

@Component({
  components: { Tabs }
})
export default class Missions extends Vue {
  @Meta
  metas() {
    return {
      title: this.$t('menu.missions'),
      titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
    }
  }
}
